import React from 'react';
import { Image, StyleSheet, Text, View } from './base_components';
import TextButton from './buttons/text_button';

const styles = StyleSheet.create({
  plan: {
    flex: 1,
    margin: '1rem',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    paddingTop: '2rem',
    paddingBottom: '2rem',
    maxWidth: '31rem',
    minWidth: '25rem',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    borderWidth: 1,
    borderColor: '#D5D7DA',
    borderRadius: '2rem',
  },
  top: {
    height: '12rem',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    borderBottomColor: '#D5D7DA',
    borderBottomWidth: 1,
  },
  name: { color: 'black', fontSize: '2.4rem', fontWeight: '600' },
  description: {
    marginTop: '2rem',
    color: '#6B7280',
    fontSize: '1.4rem',
    fontWeight: '500',
  },
  price: {
    marginTop: '1rem',
    display: 'inline-block',
    height: '4rem',
    lineHeight: '4rem',
    verticalAlign: 'baseline',
  },
  priceLarge: {
    display: 'inline',
    color: 'black',
    fontSize: '3rem',
    fontWeight: '600',
    lineHeight: '4rem',
    verticalAlign: 'baseline',
  },
  priceSmall: {
    display: 'inline',
    color: '#6B7280',
    fontSize: '1.4rem',
    fontWeight: '400',
    lineHeight: '4rem',
    verticalAlign: 'baseline',
  },
  button: { marginTop: '1rem', alignSelf: 'stretch', height: '4rem' },
  bottom: {
    marginTop: '2rem',
    alignSelf: 'stretch',
    height: '20rem',
    flexDirection: 'column',
  },
  includes: {
    marginBottom: '1rem',
    color: 'black',
    fontSize: '1.6rem',
    fontWeight: '400',
  },
  bullet: {
    height: '2.6rem',
    marginLeft: '0.4rem',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  check: {
    width: '1.4rem',
    height: '1.4rem',
    filter: 'var(--plan-check-icon)',
  },
  bulletText: {
    marginLeft: '1rem',
    color: '#0A0D12',
    fontSize: '1.4rem',
    fontWeight: 'normal',
  },
});

const CHECK = require('../assets/img/check_black.svg');

const PLAN_DATA = [
  {
    prefix: 'starter',
    description:
      'Perfect for individuals who need relaiable storage for their personal files.',
    bullets: [
      '2 users',
      '2 devices',
      '1 TB Active Cloud storage',
      '3-Day Cloud Retention',
      '1 Organization',
    ],
  },
  {
    prefix: 'pro',
    description:
      'Best for people large storage collections and a few collaborators.',
    bullets: [
      '2 users',
      '4 devices',
      '2 TB Active Cloud storage',
      '5-Day Cloud Retention',
      '1 Organization',
    ],
  },
  {
    prefix: 'business',
    description:
      'Best for companies that have large storage collections and robust collaboration.',
    bullets: [
      '4 users',
      '8 devices',
      '10 TB Active Cloud storage',
      '14-Day Cloud Retention',
      '1 Organization',
    ],
  },
  {
    prefix: 'enterprise',
    email: 'signup@maxlo.io',
    plan_name: 'Enterprise',
    description:
      'Tailored solutions for large enterprises with specific needs and high storage demands.',
    display_price: 'Custom Price',
    bullets: [
      'Unlimited users',
      'Unlimited devices',
      'Unlimited Cloud storage',
      'Custom Cloud storage providers',
      'Multi-Organization',
    ],
  },
] as any[];
export default function Plan(props) {
  const { plan, hideChecks } = props;
  const index = PLAN_DATA.findIndex((data) =>
    plan.plan_id?.startsWith?.(data.prefix)
  );
  const data = PLAN_DATA[index];
  function _onPress() {
    if (data?.email) {
      window.open(`mailto:${data.email}?subject=Enterprise+Signup`, '_blank');
    } else {
      props.onPress(plan);
    }
  }
  let content: any = null;
  if (index >= 0) {
    content = (
      <View style={[styles.plan, props.style, { order: index }]}>
        <View style={styles.top}>
          <Text style={styles.name}>{plan.plan_name}</Text>
          <Text style={styles.description}>
            {plan?.description ?? data?.description ?? ''}
          </Text>
        </View>
        <Price value={plan.display_price ?? data?.display_price ?? ''} />
        {props.onPress ? (
          <TextButton
            style={styles.button}
            type='blue'
            text={data.email ? 'Email Us' : `Choose ${plan.plan_name}`}
            onPress={_onPress}
          />
        ) : null}
        {hideChecks ? null : (
          <View style={styles.bottom}>
            <Text style={styles.includes}>Includes:</Text>
            {data?.bullets?.map((bullet, i) => (
              <Bullet key={i} text={bullet} />
            )) ?? null}
          </View>
        )}
      </View>
    );
  }
  return content;
}
function Price(props) {
  const parts = props.value.split('/');
  let large = props.value;
  let small = '';
  if (parts.length > 1) {
    large = parts[0];
    small = '/' + parts.slice(1).join('/');
  }
  return (
    <View style={styles.price}>
      <Text style={styles.priceLarge}>{large}</Text>
      {small ? <Text style={styles.priceSmall}>{small}</Text> : null}
    </View>
  );
}
function Bullet(props) {
  return (
    <View style={styles.bullet}>
      <Image style={styles.check} source={CHECK} />
      <Text style={styles.bulletText}>{props.text}</Text>
    </View>
  );
}
